import { useEffect, useRef, useState } from 'react';

import { UserIcon } from '@genially/icons';

import { GameControlButton } from '../../../../../../../../../../shared/application/components/GameControlButton/GameControlButton';
import { useHostClientContext } from '../../../../../HostClientProvider/hooks/useHostClientContext';
import { useHostGameContext } from '../../../../HostGame.context';
import { useOpenQrCodeModal } from '../../../../hooks/useOpenQrCodeModal';
import ZeroParticipantsToastWithPosition from '../ZeroParticipantsToast/ZeroParticipantsToast';
import {
  StyledText,
  StyledWarningIcon,
  Wrapper,
} from './ParticipantsGameControlButton.styled';

interface ParticipantsGameControlButtonProps {
  isVisible?: boolean;
  toastParentRef?: HTMLDivElement;
}

export const ParticipantsGameControlButton = ({
  isVisible,
  toastParentRef,
}: ParticipantsGameControlButtonProps) => {
  const { client } = useHostClientContext();
  const { participantsSidebar } = useHostGameContext();
  const { openQrCodeModal } = useOpenQrCodeModal();

  const [showToast, setShowToast] = useState(false);
  const [isToastClosed, setIsToastClosed] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  const { players } = client;
  const isZeroPlayers = players.length === 0;

  const handleClick = () => {
    participantsSidebar.toggle();
  };

  const handleOpenModal = () => {
    openQrCodeModal();
  };

  const handleToastClose = () => {
    setIsToastClosed(true);
  };

  useEffect(() => {
    if (!isZeroPlayers || isToastClosed) {
      setShowToast(false);

      return;
    }

    let timeout: NodeJS.Timeout;

    if (isVisible) {
      timeout = setTimeout(() => {
        setShowToast(true);
      }, 1000);
    } else {
      setShowToast(false);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isVisible, isZeroPlayers, isToastClosed]);

  return (
    <Wrapper ref={ref}>
      <GameControlButton Icon={UserIcon} onClick={handleClick}>
        <StyledText $isWarning={isZeroPlayers}>{players.length}</StyledText>
        {isZeroPlayers && <StyledWarningIcon />}
      </GameControlButton>

      {showToast && (
        <ZeroParticipantsToastWithPosition
          onInvite={handleOpenModal}
          onClose={handleToastClose}
          placement="bottom-start"
          referenceElement={ref}
          renderReferencePortalNode={toastParentRef}
          distance={14}
          style={{
            zIndex: 1000,
            pointerEvents: 'auto',
          }}
        />
      )}
    </Wrapper>
  );
};
